forms-comments-save
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.order_id")
    inputs-complex-to-whom(tag-scope="{ this.tagScope }.inputs.to_whom")
    inputs-complex-comment-textarea(tag-scope="{ this.tagScope }.inputs.content")
  script(type="typescript").
    this.mixin('forms.comments.save')
